import React from "react";
import styled from "styled-components";
import RemoveEmoji from "./icons";

const Button = styled.button`
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 38px;
  width: 38px;
  position: relative;
  padding: 0;
  background: transparent;
  border: none;
  font-size: 30px;
  line-height: 36px;
  &[aria-checked="true"] {
    svg {
      display: inline;
      position: absolute;
    }
  }
`;

const RemoveCircle = styled.div`
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EmojiIcon = styled.div`
  height: 30px;
`;

const EmojiButton = ({ selected, emoji, onClick }) => (
  <Button onClick={onClick} aria-label={emoji.label}>
    {selected && (
      <RemoveCircle data-testid="delete-emoji">
        <RemoveEmoji />
      </RemoveCircle>
    )}
    <EmojiIcon>{emoji.unicode}</EmojiIcon>
  </Button>
);

export default EmojiButton;
